import {
  Badge, Card, Flex, Spin, Typography
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import usePatients from "./usePatients";
import classes from "./patients.module.css";
import useDoctorPatients from "../../hooks/useDoctorPatients";

const { Text, Title } = Typography;

const Patients = () => {
  const { t } = useTranslation();
  const { contact, setCurrentContact } = usePatients();
  const { patientsData, fetchPatients, isPatientsLoading } = useDoctorPatients();

  useEffect(() => {
    fetchPatients();
  }, []);

  return (
    <>
      <Title level={4}>{t("messagesPage.sidebarTitle")} {isPatientsLoading ? <Spin size="small"/> : null}</Title>
      <div className={classes.root}>
        <Flex vertical gap={16}>
          {patientsData.map((patient) => (
            <button
              type="button"
              key={patient.id}
              onClick={() => (contact ? +contact !== patient.id && setCurrentContact(`${patient.id}`) : null)}
              className={classes.button}
            >
              <Card
                size="small"
                className={contact && contact === `${patient.id}` ? classes.buttonContentActive : classes.buttonContent}
                styles={{ body: { padding: "8px 12px" } }}
              >
                <Flex vertical>
                  <Text className={classes.name}>{patient.name} {patient.surname}</Text>
                  <Text className={classes.date}>{t("global.labels.patientFrom")} {dayjs(patient.created_at).format("YYYY").toString()}</Text>
                  {patient.lastMessage
                    ? (
                      <>
                        {patient.lastMessage.is_seen ? null : <Badge status="processing" className={classes.status} /> }
                        <Text className={classes.message}>{patient.lastMessage.content}</Text>
                        <Text className={classes.time}>
                          <span>{dayjs(patient.lastMessage.created_at).format("DD-MM-YYYY").toString()}</span>
                        &nbsp;
                          <span>{dayjs(patient.lastMessage.created_at).format("HH:mm").toString()}</span>
                        </Text>
                      </>
                    )
                    : <Text>{t("messagesPage.noMessages")}</Text>}
                </Flex>
              </Card>
            </button>
          ))}
        </Flex>
      </div>
    </>
  );
};

export default Patients;
